import API from '@/service/api'

export function canExecute({ warnings, acknowledged }) {
  if (!warnings || warnings.length === 0) return true
  return acknowledged === true
}

export function validateOrders(ids) {
  return API().post('/data-cleanup/orders/validate', { ids }).then(r => r.data)
}

export function executeOrderDeletion(ids, warningsAcknowledged) {
  return API().post('/data-cleanup/orders/execute', { ids, warningsAcknowledged }).then(r => r.data)
}

export function validateInventory(storageIds, locationIds) {
  return API().post('/data-cleanup/inventory/validate', { storageIds, locationIds }).then(r => r.data)
}

export function executeInventoryDeletion(storageIds, locationIds) {
  return API().post('/data-cleanup/inventory/execute', { storageIds, locationIds }).then(r => r.data)
}

export function fetchDeletionLogs() {
  return API().get('/deletion-logs?_sort=created_at:DESC').then(r => r.data)
}

export function restoreOrder(logId) {
  return API().post('/data-cleanup/orders/restore', { logId }).then(r => r.data)
}
